import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              FAQ
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              Get answers to the most common questions about Vigorbuy Spreadsheet
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-4.5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-400'}`}>
                    <i className={`text-sm transition-transform duration-200 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}